import React, { useEffect, useState, useCallback, useRef } from 'react';
// import soundUrl from './sound.mp3';
import soundUrl from './sound.mp3.base64';
import * as styles from './style';

const CallBell = (props) => {
  const { audioRef: audioRefProp, paused, ...rest } = props;
  const audioRef = useRef();
  const audioRefCallback = useCallback(
    audio => {
      audioRef.current = audio;
      if (audioRefProp) {
        if (typeof audioRefProp === 'function') {
          audioRefProp(audio);
        } else {
          audioRefProp.current = audio;
        }
      }
    },
    [audioRefProp]
  );

  const [autoPlay] = useState(!paused);
  const handleState = useCallback(() => {
    if (paused) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
  }, [paused]);

  useEffect(() => {
    audioRef.current.volume = 1;
  });

  useEffect(() => {
    handleState();
  }, [paused]);

  return (
    <React.Fragment>
      <audio ref={audioRefCallback} loop autoPlay={autoPlay}>
        <source src={soundUrl} />
      </audio>
      <styles.Icon fontSize="inherit" paused={paused} {...rest} />
    </React.Fragment>
  );
};

export default CallBell;



// WEBPACK FOOTER //
// ./src/components/CallBell/index.js